import actiontypes from "../actions/actiontypes";
import { handleResetPasswordWatcher, setLoginError } from "../actions/loginactioncreators";
import { put, takeLatest, select } from 'redux-saga/effects'
import * as queryString from 'query-string'
import { forgotPassword } from '../../lib/services'
import getLocale from "../helpers/getLocale";

export function* resetPasswordAsync(action) {
  try {
    const parsedQueryString = queryString.parse(window.location.search);
    let payload = action.payload;
    if (parsedQueryString.client_id) {
      payload.clientId = parsedQueryString.client_id
    }
    const locale = yield select(getLocale);
    const options = {
      headers: {
        'Accept-Language': locale,
      }
    };
    let { data } = yield forgotPassword(payload, options);
    yield put(handleResetPasswordWatcher(data));
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        yield put(setLoginError([e.response.data.reasonMessage]))
      } else {
        yield put(setLoginError(['unknown error']))
      }
    } else if (e.request) {
      yield put(setLoginError(['unknown error']))
    }
  }
}

export function* watchResetPasswordAsync() {
  yield takeLatest(actiontypes.USER_RESET_PASSWORD, resetPasswordAsync);
}